import Vue from 'vue';
import Antd from 'ant-design-vue';
import App from './App';
import 'ant-design-vue/dist/antd.css';
import axios from 'axios';
import router from './router';

Vue.config.productionTip = false;
Vue.prototype.axios = axios;

Vue.use(Antd);

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')